import './src/injectArguments';
import './src/contractInjection';
import { InjectableClass } from './src/injectableClass';

export { InjectableClass }


// WEBPACK FOOTER //
// ./node_modules/@fino/lib-injection/index.js